<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.administracao.envioSms"
        ref="RkmDataTable"
        sort-by="data_hora_envio"
        sort-desc
    />
</template>

<script>
export default {
    computed: {
        fields() {
            return [
                {
                    key: 'data_hora_envio',
                    label: 'Data/Hora envio',
                    name: 'administracao_envio_sms.created_at',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'cidadao_nome',
                    label: 'Cidadão',
                    name: 'cadastro_cidadao.nome',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'status',
                    label: 'Status',
                    name: 'administracao_envio_sms.status',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'mensagem',
                    label: 'Mensagem',
                    name: 'administracao_envio_sms.mensagem',
                    searchable: true,
                    sortable: true,
                }
            ]
        },
    },
    inject: ['repositories'],
}
</script>